import React from 'react';

type BrandWordProps = {
  className?: string;
};

/** Scoutly product wordmark — Scout + orange ly accent. */
export default function BrandWord({ className = '' }: BrandWordProps) {
  return (
    <span className={['brand-word', className].filter(Boolean).join(' ')} data-testid="brand-word">
      Scout<span className="brand-word-accent">ly</span>
    </span>
  );
}
